import FullScreenDialog from './FullScreenDialog';

export default FullScreenDialog;
